import React, { memo } from 'react'
import SortArrowsIcon from 'transfix-icons/build/SortArrowsIcon'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { ISvgIconProps } from '../SvgIcon'

export interface ISortArrowToggleProps extends Omit<ISvgIconProps, 'className' | 'color'> {
  /**
   * @default 'asc'
   */
  direction?: 'asc' | 'desc'
  onClick?: () => void
}

const useSortArrowsStyles = makeStyles({
  asc: {
    '& > path:first-of-type': {
      fill: brandColors.skyBlue5,
    },
    '& > path:last-of-type': {
      fill: brandColors.coolGray3,
    },
  },
  desc: {
    '& > path:first-of-type': {
      fill: brandColors.coolGray3,
    },
    '& > path:last-of-type': {
      fill: brandColors.skyBlue5,
    },
  },
})

export const SortArrowToggle = memo<ISortArrowToggleProps>(({ direction = 'asc', ...rest }) => {
  const classes = useSortArrowsStyles({ direction })
  return <SortArrowsIcon color='activeBlue' className={classes[direction]} {...rest} />
})

export default SortArrowToggle
